import { useEffect, useState } from "react";

export const useIsMobile = () => {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const checkScreen = () => {
			setIsMobile(window.innerWidth < 640); // Tailwind 'sm' breakpoint
		};

		checkScreen(); // initial check
		window.addEventListener("resize", checkScreen);

		return () => window.removeEventListener("resize", checkScreen);
	}, []);

	return isMobile;
};

export const useIsTablet = () => {
	const [isTablet, setIsTablet] = useState(false);

	useEffect(() => {
		const checkScreen = () => {
			setIsTablet(window.innerWidth < 1024); // Tailwind 'sm' breakpoint
		};

		checkScreen(); // initial check
		window.addEventListener("resize", checkScreen);

		return () => window.removeEventListener("resize", checkScreen);
	}, []);

	return isTablet;
};

export const useIsDesktop = () => {
	const [isDesktop, setIsDesktop] = useState(false);

	useEffect(() => {
		const checkScreen = () => {
			setIsDesktop(window.innerWidth >= 1024); // Tailwind 'sm' breakpoint
		};

		checkScreen(); // initial check
		window.addEventListener("resize", checkScreen);

		return () => window.removeEventListener("resize", checkScreen);
	}, []);

	return isDesktop;
};
